/**
 * SplitMix64 — عیناً مثلِ Rng ِ Backend/internal/mafia/rng.go (و MafiaRng ِ C#)، تا وقتی مسابقه‌ی فلش‌ها به
 * سرور و اپ رسید، یک بذر در هر سه زبان یک تخته بدهد (docs/arrow-race.md).
 */
const MASK = (1n << 64n) - 1n;

export class Rng {
  private s: bigint;

  constructor(seed: number | bigint) { this.s = BigInt(seed) & MASK; }

  next64(): bigint {
    this.s = (this.s + 0x9E3779B97F4A7C15n) & MASK;
    let z = this.s;
    z = ((z ^ (z >> 30n)) * 0xBF58476D1CE4E5B9n) & MASK;
    z = ((z ^ (z >> 27n)) * 0x94D049BB133111EBn) & MASK;
    return z ^ (z >> 31n);
  }

  /** [0, n). برای n ≤ ۱ صفر. */
  next(n: number): number {
    if (n <= 1) return 0;
    return Number(this.next64() % BigInt(n));
  }

  /** [0, 1). */
  value(): number { return Number(this.next64() >> 11n) * (1 / 9007199254740992); }

  chance(p: number): boolean { return this.value() < p; }
}
